import React from 'react'

import labels from '../../configuration/labels'
import '../../styles/scss/elements/booking-stepper.scss'

const bookingSteps = {
  details: 'tour-details',
  pricing: 'tour-pricing',
}

const BookingStepper = ({currentStep, isMobile, onSetCurrentStep}) => {
  return (
    <div className="u-full-width u-flex u-flex-align-center u-flex-justify-center booking-stepper">
      <button
        aria-label={isMobile ? labels.stepperDepartureDateMobile : labels.stepperDepartureDate}
        className={`u-flex ${currentStep === bookingSteps.pricing ? 'booking-stepper__selected' : ''}`}
        disabled={currentStep === bookingSteps.pricing}
        onClick={() => onSetCurrentStep(bookingSteps.pricing)}
      >
        <span>1</span>
        {isMobile ? labels.stepperDepartureDateMobile : labels.stepperDepartureDate}
      </button>
      <button
        aria-label={isMobile ? labels.stepperPassengerInfoMobile : labels.stepperPassengerInfo}
        className={`u-flex ${currentStep === bookingSteps.details ? 'booking-stepper__selected' : ''}`}
        disabled
        onClick={() => onSetCurrentStep(bookingSteps.details)}
      >
        <span>2</span>
        {isMobile ? labels.stepperPassengerInfoMobile : labels.stepperPassengerInfo}
      </button>
    </div>
  )
}

export default BookingStepper
